import {
  Building,
  CandlestickChart,
  Globe2,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { AssetClassCode } from "@/types/assets";

export type AssetClassDefinition = {
  id: AssetClassCode;
  name: string;
  code: string;
  description: string;
  color: string;
  icon: LucideIcon;
};

export const ASSET_CLASSES_CATALOG: AssetClassDefinition[] = [
  {
    id: AssetClassCode.ACAO,
    name: "A\u00e7\u00f5es",
    code: "ACAO",
    description:
      "Empresas listadas em bolsa com maior volatilidade e potencial de crescimento.",
    color: "var(--color-brand)",
    icon: CandlestickChart,
  },
  {
    id: AssetClassCode.FII,
    name: "FIIs",
    code: "FII",
    description:
      "Fundos Imobili\u00e1rios focados em renda recorrente e prote\u00e7\u00e3o inflacion\u00e1ria.",
    color: "var(--color-accent-fii)",
    icon: Building,
  },
  {
    id: AssetClassCode.BDRS,
    name: "BDRs",
    code: "BDR",
    description:
      "Recibos que representam a\u00e7\u00f5es de empresas estrangeiras negociadas no Brasil.",
    color: "var(--color-info)",
    icon: Globe2,
  },
  /*{
    id: 'etfs',
    name: 'ETFs',
    code: 'ETF',
    description: 'Fundos de \u00edndice que replicam carteiras diversificadas de mercado.',
    color: 'var(--color-accent-acao)',
    icon: Layers,
  },
  {
    id: 'reits',
    name: 'REITs',
    code: 'REIT',
    description: 'Fundos imobili\u00e1rios internacionais com exposi\u00e7\u00e3o global.',
    color: 'var(--color-success)',
    icon: Building2,
  },
  {
    id: 'crypto',
    name: 'Cripto',
    code: 'CRYPTO',
    description: 'Ativos digitais descentralizados com alta volatilidade.',
    color: 'var(--color-warning)',
    icon: Coins,
  },*/
];

export const ASSET_CLASS_BY_ID = ASSET_CLASSES_CATALOG.reduce<
  Record<AssetClassCode, AssetClassDefinition>
>((acc, group) => {
  acc[group.id] = group;
  return acc;
}, {} as Record<AssetClassCode, AssetClassDefinition>);
